export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_GDM_1.36a216d7.jpg";